// src/features/auth/RequireAdmin.jsx
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Loader } from '@/shared/components/Loader';

const RequireAdmin = () => {
  const { 
    isAuthenticated, 
    isAdmin, 
    isActive,
    loading 
  } = useAuth();
  
  const location = useLocation();

  // ============================================
  // LOADING STATE
  // ============================================
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <Loader size="lg" />
          <p className="mt-4 text-gray-600">Verifying access...</p>
        </div>
      </div>
    );
  }

  // ============================================
  // NOT AUTHENTICATED
  // ============================================
  
  if (!isAuthenticated) {
    return (
      <Navigate 
        to="/login" 
        state={{ from: location }} 
        replace 
      />
    );
  }

  // ============================================
  // INACTIVE ACCOUNT CHECK
  // ============================================
  
  if (!isActive) {
    return (
      <Navigate 
        to="/account-disabled" 
        replace 
      />
    );
  }

  // ============================================
  // ADMIN ROLE CHECK
  // ============================================
  
  if (!isAdmin) {
    // Regular user trying to access admin routes
    return (
      <Navigate 
        to="/unauthorized" 
        state={{ from: location }} 
        replace 
      />
    );
  }

  // ============================================
  // AUTHORIZED ADMIN - RENDER PROTECTED CONTENT
  // ============================================
  
  return <Outlet />;
};

export default RequireAdmin;